var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarGliderHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_177109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5 319C219.423 319 268 312.294 268 304.023C268 295.751 219.423 289.046 159.5 289.046C99.5771 289.046 51 295.751 51 304.023C51 312.294 99.5771 319 159.5 319Z",
    fill: "#EDB27C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62 255.913C257.131 254.935 256.46 253.957 255.605 253.163C254.75 252.368 253.773 251.634 252.674 251.084C251.575 250.534 250.354 250.167 249.011 249.923C249.011 249.923 243.027 248.211 231.548 254.263C226.297 257.014 220.558 258.848 214.635 259.214C207.858 259.642 199.309 258.725 190.456 253.835L188.197 252.429L187.342 254.752L185.816 256.891C185.327 257.503 184.9 258.053 184.411 258.603C183.923 259.153 183.373 259.703 182.641 260.376C183.373 261.232 184.106 262.026 184.9 262.821C185.694 263.616 186.487 264.349 187.342 265.144C188.197 265.878 189.113 266.611 190.029 267.345C190.945 268.078 191.921 268.751 192.959 269.423C193.936 270.096 195.035 270.707 196.073 271.318C197.172 271.93 198.271 272.541 199.432 273.091C200.592 273.641 201.752 274.13 202.973 274.619C204.011 275.047 205.11 275.414 206.209 275.781C207.308 276.148 208.407 276.453 209.506 276.759C210.605 277.065 211.765 277.309 212.925 277.554C214.085 277.798 215.246 277.981 216.406 278.165C217.566 278.348 218.726 278.471 219.947 278.593C221.107 278.715 222.328 278.776 223.488 278.837C224.648 278.898 225.87 278.898 227.03 278.898C228.19 278.898 229.35 278.837 230.51 278.776C231.792 278.715 233.074 278.593 234.357 278.409C235.639 278.226 236.86 278.043 238.142 277.798C239.363 277.554 240.585 277.248 241.745 276.942C242.905 276.637 244.004 276.27 245.103 275.842C246.202 275.414 247.24 274.986 248.217 274.497C249.194 274.008 250.11 273.458 250.964 272.908C252.002 272.235 252.979 271.502 253.834 270.707C254.689 269.912 255.422 269.056 256.093 268.201C256.704 267.284 257.253 266.367 257.681 265.389C258.108 264.411 258.352 263.432 258.536 262.393C258.719 261.354 258.719 260.315 258.597 259.214C258.475 257.931 258.108 256.891 257.62 255.913Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.665 253.102C254.81 252.307 253.833 251.573 252.734 251.023C251.635 250.473 250.414 250.106 249.071 249.862C249.071 249.862 243.453 248.272 232.707 253.652C236.065 254.936 240.278 257.381 242.415 261.599C242.659 262.088 242.11 262.577 241.683 262.271L239.179 260.743C239.179 260.743 245.224 266.428 243.026 276.392C243.759 276.148 244.491 275.903 245.163 275.659C246.262 275.231 247.3 274.803 248.277 274.314C249.254 273.825 250.17 273.275 251.024 272.725C252.062 272.052 253.039 271.319 253.894 270.524C254.749 269.729 255.482 268.873 256.153 268.018C256.764 267.101 257.313 266.184 257.741 265.206C258.168 264.227 258.412 263.249 258.596 262.21C258.779 261.171 258.779 260.132 258.657 259.031C258.535 257.931 258.229 256.892 257.68 255.914C257.13 254.875 256.459 253.958 255.665 253.102Z",
    fill: "#332D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62 255.914C257.131 254.936 256.46 253.958 255.605 253.163C254.811 252.369 253.895 251.696 252.857 251.207C252.979 251.329 253.163 251.452 253.285 251.574C254.078 252.369 254.75 253.347 255.239 254.325C255.727 255.303 256.032 256.403 256.154 257.442C256.277 258.543 256.277 259.582 256.093 260.621C255.971 261.66 255.666 262.638 255.3 263.616C254.933 264.595 254.384 265.512 253.773 266.367C253.163 267.223 252.43 268.079 251.575 268.874C250.72 269.668 249.804 270.402 248.766 271.074C247.912 271.625 246.996 272.175 246.019 272.664C245.042 273.153 244.065 273.581 242.966 274.009C241.928 274.437 240.829 274.803 239.669 275.109C238.509 275.415 237.349 275.72 236.127 275.965C234.906 276.209 233.685 276.393 232.464 276.576C231.243 276.76 229.961 276.821 228.678 276.943C227.518 277.004 226.419 277.065 225.259 277.065C224.099 277.065 222.939 277.065 221.779 277.004C220.619 276.943 219.459 276.882 218.298 276.76C217.138 276.637 215.978 276.515 214.818 276.332C213.658 276.148 212.498 275.965 211.399 275.72C210.3 275.476 209.14 275.231 208.041 274.926C206.942 274.62 205.843 274.314 204.744 273.948C203.645 273.581 202.607 273.214 201.569 272.786C200.408 272.297 199.248 271.808 198.088 271.258C196.989 270.708 195.89 270.096 194.791 269.485C193.753 268.874 192.715 268.201 191.738 267.59C190.761 266.918 189.784 266.245 188.869 265.512C187.953 264.778 187.098 264.044 186.243 263.311C185.388 262.577 184.594 261.783 183.801 260.988C183.495 260.682 183.251 260.377 182.946 260.071C182.824 260.193 182.763 260.254 182.641 260.377C183.373 261.232 184.106 262.027 184.9 262.822C185.694 263.616 186.487 264.35 187.342 265.145C188.197 265.878 189.113 266.612 190.029 267.345C190.945 268.079 191.921 268.751 192.959 269.424C193.936 270.096 195.035 270.708 196.073 271.319C197.172 271.93 198.271 272.542 199.432 273.092C200.592 273.642 201.752 274.131 202.973 274.62C204.011 275.048 205.11 275.415 206.209 275.781C207.308 276.148 208.407 276.454 209.506 276.76C210.605 277.065 211.765 277.31 212.925 277.554C214.085 277.799 215.246 277.982 216.406 278.166C217.566 278.349 218.726 278.471 219.947 278.593C221.107 278.716 222.328 278.777 223.488 278.838C224.648 278.899 225.87 278.899 227.03 278.899C228.19 278.899 229.35 278.838 230.51 278.777C231.792 278.716 233.074 278.593 234.357 278.41C235.639 278.227 236.86 278.043 238.142 277.799C239.363 277.554 240.585 277.249 241.745 276.943C242.905 276.637 244.004 276.27 245.103 275.843C246.202 275.415 247.24 274.987 248.217 274.498C249.194 274.009 250.11 273.458 250.964 272.908C252.002 272.236 252.979 271.502 253.834 270.708C254.689 269.913 255.422 269.057 256.093 268.201C256.704 267.284 257.253 266.367 257.681 265.389C258.108 264.411 258.352 263.433 258.536 262.394C258.719 261.355 258.719 260.315 258.597 259.215C258.475 257.931 258.108 256.892 257.62 255.914Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.426 157.249V243.993L120.913 280.366C120.913 280.366 72.4329 248.333 75.9132 192.338L116.639 157.249H157.426Z",
    fill: "url(#paint0_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0257 189.587L75.8507 192.338C72.3704 248.333 120.85 280.365 120.85 280.365L122.133 279.082C82.2007 249.128 77.9266 208.904 79.0257 189.587Z",
    fill: "url(#paint1_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.426 157.249V243.993L194 280.366C194 280.366 242.48 248.333 238.999 192.338L198.274 157.249H157.426Z",
    fill: "url(#paint2_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.826 189.587L239.001 192.338C242.481 248.333 194.001 280.365 194.001 280.365L192.719 279.082C232.651 249.128 236.986 208.904 235.826 189.587Z",
    fill: "url(#paint3_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9443 184.147L68.7692 183.291C68.7692 183.291 58.2062 186.348 55.0312 193.989C52.5278 199.857 59.5495 206.154 64.5562 203.953C69.563 201.752 71.2726 197.168 71.2726 197.168L71.5168 198.818C71.8832 199.98 73.4707 200.224 74.0813 199.185C74.875 197.901 75.6688 195.762 75.852 192.277C76.2794 184.758 71.9443 184.147 71.9443 184.147Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.179 134.02C106.137 148.569 85.5605 164.951 68.7695 183.291L75.8523 192.338C96.673 181.579 120.302 168.497 145.092 154.498L128.179 134.02Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2494 199.796C72.1884 199.735 72.0663 199.674 72.0052 199.613C72.1273 199.368 72.1884 199.246 72.1884 199.246L72.2494 199.796ZM56.008 200.958C55.3364 199.307 55.2143 197.412 56.0691 195.639C59.4883 188.059 70.1124 185.308 70.1124 185.308C86.7812 168.008 109.128 150.953 130.804 137.199L128.24 134.081C106.198 148.63 85.6211 165.013 68.8302 183.352C68.8302 183.352 58.2672 186.409 55.0921 194.05C53.932 196.495 54.6037 199.001 56.008 200.958Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9443 184.147L68.7692 183.291C68.7692 183.291 58.2062 186.348 55.0312 193.989C52.5278 199.857 59.5495 206.154 64.5562 203.953C69.563 201.752 71.2726 197.168 71.2726 197.168L71.5168 198.818C71.8832 199.98 73.4707 200.224 74.0813 199.185C74.875 197.901 75.6688 195.762 75.852 192.277C76.2794 184.758 71.9443 184.147 71.9443 184.147Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.179 134.02C106.137 148.569 85.5605 164.951 68.7695 183.291L75.8523 192.338C96.673 181.579 120.302 168.497 145.092 154.498L128.179 134.02Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M72.2494 199.796C72.1884 199.735 72.0663 199.674 72.0052 199.613C72.1273 199.368 72.1884 199.246 72.1884 199.246L72.2494 199.796ZM56.008 200.958C55.3364 199.307 55.2143 197.412 56.0691 195.639C59.4883 188.059 70.1124 185.308 70.1124 185.308C86.7812 168.008 109.128 150.953 130.804 137.199L128.24 134.081C106.198 148.63 85.6211 165.013 68.8302 183.352C68.8302 183.352 58.2672 186.409 55.0921 194.05C53.932 196.495 54.6037 199.001 56.008 200.958Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.457 184.147L246.632 183.291C246.632 183.291 257.195 186.348 260.37 193.989C262.873 199.857 255.852 206.154 250.845 203.953C245.838 201.752 244.129 197.168 244.129 197.168L243.884 198.818C243.518 199.98 241.93 200.224 241.32 199.185C240.526 197.901 239.732 195.762 239.549 192.277C239.122 184.758 243.457 184.147 243.457 184.147Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.222 134.02C209.264 148.569 229.84 164.951 246.631 183.291L239.548 192.338C218.728 181.579 195.098 168.497 170.309 154.498L187.222 134.02Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.212 199.246C243.212 199.246 243.273 199.368 243.395 199.613C243.334 199.674 243.212 199.735 243.151 199.796L243.212 199.246ZM260.431 194.05C257.195 186.409 246.693 183.352 246.693 183.352C229.841 164.952 209.325 148.63 187.283 134.081L184.719 137.199C206.394 150.953 228.742 168.008 245.41 185.308C245.41 185.308 256.034 188.12 259.454 195.639C260.247 197.473 260.186 199.307 259.515 200.958C260.858 199.001 261.469 196.495 260.431 194.05Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.457 184.147L246.632 183.291C246.632 183.291 257.195 186.348 260.37 193.989C262.873 199.857 255.852 206.154 250.845 203.953C245.838 201.752 244.129 197.168 244.129 197.168L243.884 198.818C243.518 199.98 241.93 200.224 241.32 199.185C240.526 197.901 239.732 195.762 239.549 192.277C239.122 184.758 243.457 184.147 243.457 184.147Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.222 134.02C209.264 148.569 229.84 164.951 246.631 183.291L239.548 192.338C218.728 181.579 195.098 168.497 170.309 154.498L187.222 134.02Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M243.212 199.246C243.212 199.246 243.273 199.368 243.395 199.613C243.334 199.674 243.212 199.735 243.151 199.796L243.212 199.246ZM260.431 194.05C257.195 186.409 246.693 183.352 246.693 183.352C229.841 164.952 209.325 148.63 187.283 134.081L184.719 137.199C206.394 150.953 228.742 168.008 245.41 185.308C245.41 185.308 256.034 188.12 259.454 195.639C260.247 197.473 260.186 199.307 259.515 200.958C260.858 199.001 261.469 196.495 260.431 194.05Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.607 295.159C103.02 289.291 110.164 283.422 120.849 280.305H134.404C131.9 292.836 117.307 302.373 108.698 299.438C106.744 298.766 105.157 297.177 104.607 295.159Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.571 280.366C128.908 291.675 115.536 299.928 107.477 297.177C106.378 296.81 105.462 296.138 104.668 295.282C105.217 297.238 106.805 298.828 108.759 299.5C117.429 302.495 132.022 292.898 134.464 280.366H132.571Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.169 229.811C213.169 229.261 213.108 228.65 213.108 228.1C212.986 225.899 212.803 223.698 212.497 221.498C212.436 220.947 212.375 220.397 212.253 219.786C212.192 219.236 212.07 218.686 212.009 218.135C211.948 217.585 211.826 217.035 211.765 216.485C211.642 215.935 211.581 215.384 211.459 214.895C211.337 214.345 211.215 213.795 211.154 213.184C211.032 212.634 210.91 212.083 210.788 211.533C210.665 210.983 210.543 210.433 210.421 209.883C210.238 209.21 210.116 208.477 209.933 207.804C209.872 207.376 209.75 207.01 209.689 206.582C202.911 179.073 188.99 153.215 190.883 135.609H157.423H123.963C125.856 153.215 111.935 179.012 105.157 206.582C105.096 207.01 104.974 207.376 104.913 207.804C104.73 208.477 104.608 209.21 104.425 209.883C104.303 210.433 104.18 210.983 104.058 211.533C103.936 212.083 103.814 212.634 103.692 213.184C103.57 213.734 103.448 214.284 103.387 214.895C103.265 215.446 103.203 215.996 103.081 216.485C102.959 217.035 102.898 217.585 102.837 218.135C102.776 218.686 102.654 219.236 102.593 219.786C102.532 220.336 102.41 220.886 102.349 221.498C102.043 223.698 101.86 225.899 101.738 228.1C101.677 228.65 101.677 229.261 101.677 229.811C101.005 247.233 105.524 264.594 120.849 280.366H134.404C134.587 267.345 142.952 259.398 157.423 259.337C171.894 259.337 180.259 267.345 180.442 280.366H193.997C209.322 264.594 213.841 247.172 213.169 229.811Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M213.17 229.811C213.17 229.261 213.109 228.65 213.109 228.1C212.987 225.899 212.804 223.698 212.498 221.498C212.437 220.947 212.376 220.397 212.254 219.786C212.193 219.236 212.071 218.686 212.01 218.135C211.949 217.585 211.827 217.035 211.766 216.485C211.643 215.935 211.582 215.384 211.46 214.895C211.338 214.345 211.216 213.795 211.155 213.184C211.033 212.634 210.911 212.083 210.789 211.533C210.666 210.983 210.544 210.433 210.422 209.883C210.239 209.21 210.117 208.477 209.934 207.804C209.873 207.376 209.751 207.01 209.69 206.582C202.912 179.073 188.991 153.215 190.884 135.609H186.61C185.45 153.521 198.882 179.195 205.538 206.521C205.599 206.948 205.721 207.315 205.782 207.743C205.965 208.477 206.087 209.149 206.27 209.883C206.392 210.433 206.515 210.983 206.637 211.533C206.759 212.083 206.881 212.634 207.003 213.184C207.125 213.734 207.247 214.345 207.308 214.895C207.43 215.446 207.491 215.996 207.614 216.546C207.736 217.096 207.797 217.646 207.858 218.196C207.919 218.747 208.041 219.297 208.102 219.908C208.163 220.458 208.285 221.07 208.346 221.62C208.652 223.882 208.835 226.082 208.957 228.344C209.018 228.894 209.018 229.506 209.018 230.056C209.69 247.295 205.415 264.533 191.067 280.244H194.059C209.323 264.594 213.841 247.172 213.17 229.811Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.909 280.366H123.901C109.552 264.655 105.278 247.417 105.949 230.178C105.949 229.628 106.011 229.016 106.011 228.466C106.133 226.204 106.316 224.004 106.621 221.742C106.682 221.192 106.743 220.58 106.865 220.03C106.926 219.48 107.049 218.93 107.11 218.319C107.171 217.768 107.293 217.218 107.354 216.668C107.476 216.118 107.537 215.568 107.659 215.017C107.781 214.467 107.903 213.856 107.964 213.306C108.087 212.756 108.209 212.205 108.331 211.655C108.453 211.105 108.575 210.555 108.697 210.005C108.88 209.271 109.002 208.599 109.186 207.865C109.247 207.437 109.369 207.071 109.43 206.643C116.085 179.256 129.457 153.582 128.358 135.731H124.084C125.976 153.337 112.055 179.134 105.278 206.704C105.217 207.132 105.095 207.498 105.034 207.926C104.85 208.599 104.728 209.332 104.545 210.005C104.423 210.555 104.301 211.105 104.179 211.655C104.057 212.205 103.935 212.756 103.812 213.306C103.69 213.856 103.568 214.406 103.507 215.017C103.385 215.568 103.324 216.118 103.202 216.607C103.08 217.157 103.019 217.707 102.958 218.257C102.897 218.808 102.774 219.358 102.713 219.908C102.652 220.458 102.53 221.008 102.469 221.62C102.164 223.82 101.981 226.021 101.859 228.222C101.798 228.772 101.798 229.383 101.798 229.933C101.065 247.172 105.583 264.594 120.909 280.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.238 295.159C211.825 289.291 204.681 283.422 193.996 280.305H180.441C182.945 292.836 197.538 302.373 206.147 299.438C208.101 298.766 209.688 297.177 210.238 295.159Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.334 280.366C185.998 291.675 199.369 299.928 207.429 297.177C208.528 296.81 209.444 296.138 210.238 295.282C209.688 297.238 208.101 298.828 206.147 299.5C197.477 302.495 182.884 292.898 180.441 280.366H182.334Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.104 204.32C191.921 174.183 178.732 159.023 179.282 135.671H157.423H135.564C136.114 158.962 122.986 174.183 122.742 204.32C122.742 204.626 122.742 204.87 122.742 205.176C122.742 223.148 138.251 237.759 157.423 237.759C176.595 237.759 192.104 223.148 192.104 205.176C192.104 204.87 192.104 204.626 192.104 204.32Z",
    fill: "url(#paint4_radial_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.681 56.9953L215.736 51.677L202.486 37.4336L190.152 24.1072C200.593 2.40594 224.772 -4.37952 233.198 5.3402C245.043 18.9111 236.373 46.1141 220.681 56.9953Z",
    fill: "url(#paint5_radial_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.737 51.6767L202.487 37.4333C203.464 37.8001 204.38 38.228 205.296 38.6559C206.212 39.0838 207.25 39.634 208.166 38.9004C208.654 38.5337 208.898 37.8612 208.837 37.1888C208.715 35.8439 207.677 34.927 206.639 34.1323L210.486 33.7044C211.463 33.5821 211.951 32.3595 211.28 31.6259C210.486 30.8312 209.509 30.2199 208.41 29.8531C206.639 29.2418 204.747 29.2418 202.915 29.2418C204.563 28.6917 206.273 28.1415 207.983 27.5913C208.471 27.4079 208.96 27.2245 209.204 26.7966C209.448 26.3076 209.143 25.6352 208.715 25.2684C208.227 24.9016 207.616 24.8405 207.067 24.7793C205.052 24.5959 202.976 24.6571 200.961 25.0238C208.776 12.6144 221.965 5.15649 228.01 9.92466C237.657 20.1946 225.079 44.4633 215.737 51.6767Z",
    fill: "url(#paint6_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.078 36.3943C229.048 45.3194 222.881 52.3493 208.166 37.9837C199.984 29.9756 191.131 24.2294 190.337 23.8015C190.276 23.9237 190.215 23.9849 190.215 24.046L202.549 37.3724L215.798 51.6158L220.744 56.9341C235.703 46.6031 244.251 21.4174 234.848 7.35742C238.695 16.0379 236.558 28.6919 233.078 36.3943Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3801 56.9953L103.326 51.677L116.575 37.4336L128.909 24.1072C118.468 2.40594 94.2892 -4.37952 85.8632 5.3402C74.018 18.9111 82.6882 46.1141 98.3801 56.9953Z",
    fill: "url(#paint7_radial_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.328 51.6767L116.577 37.4333C115.6 37.8001 114.685 38.228 113.769 38.6559C112.853 39.0838 111.815 39.634 110.899 38.9004C110.411 38.5337 110.166 37.8612 110.227 37.1888C110.349 35.8439 111.387 34.927 112.425 34.1323L108.579 33.7044C107.602 33.5821 107.113 32.3595 107.785 31.6259C108.579 30.8312 109.556 30.2199 110.655 29.8531C112.425 29.2418 114.318 29.2418 116.15 29.2418C114.501 28.6917 112.792 28.1415 111.082 27.5913C110.594 27.4079 110.105 27.2245 109.861 26.7966C109.617 26.3076 109.922 25.6352 110.349 25.2684C110.838 24.9016 111.449 24.8405 111.998 24.7793C114.013 24.5959 116.089 24.6571 118.104 25.0238C110.227 12.6144 97.0999 5.15649 91.0551 9.92466C81.3469 20.1946 93.9859 44.4633 103.328 51.6767Z",
    fill: "url(#paint8_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9864 36.3943C90.0162 45.3194 96.1831 52.3493 110.898 37.9837C119.08 29.9756 127.933 24.2294 128.727 23.8015C128.788 23.9237 128.849 23.9849 128.849 24.046L116.515 37.3724L103.327 51.6769L98.3812 56.9953C83.422 46.6642 74.8738 21.4785 84.2768 7.35742C80.3691 16.0379 82.5061 28.6919 85.9864 36.3943Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.046 63.3533C209.08 40.3072 192.534 14.877 160.051 14.877C159.868 14.877 159.684 14.877 159.501 14.877C159.318 14.877 159.135 14.877 158.952 14.877C126.469 14.877 109.983 40.3072 89.9561 63.3533C68.4637 89.1503 85.3157 113.725 92.7038 120.755C110.166 137.382 135.566 146.674 159.562 146.735C183.558 146.674 208.897 137.321 226.421 120.755C233.748 113.786 250.539 89.2114 229.046 63.3533Z",
    fill: "url(#paint9_radial_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.488 87.377C239.488 87.7437 239.549 88.1716 239.549 88.5384C239.549 88.1716 239.549 87.8049 239.488 87.377Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.242 85.0537C239.303 85.7261 239.425 86.3986 239.486 87.0099C239.425 86.3374 239.364 85.665 239.242 85.0537Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.099 122.833C223.916 123.016 223.671 123.2 223.488 123.322C223.671 123.139 223.916 123.016 224.099 122.833Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.488 87.133C239.488 87.0719 239.488 87.0107 239.488 87.0107C239.488 87.133 239.488 87.2553 239.549 87.4387C239.488 87.3164 239.488 87.2553 239.488 87.133Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.245 84.8705C239.245 84.8094 239.245 84.6871 239.184 84.626C239.184 84.7482 239.245 84.9316 239.245 85.0539C239.245 84.9928 239.245 84.9316 239.245 84.8705Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.609 88.6606C239.609 88.5998 239.609 88.5998 239.609 88.5391C239.548 88.5998 239.609 88.6606 239.609 88.6606Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12 84.0762C239.12 83.9539 239.059 83.8928 239.059 83.7705C239.12 83.9539 239.12 84.1984 239.181 84.3818C239.12 84.2596 239.12 84.1984 239.12 84.0762Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.178 120.938C225.506 121.61 224.773 122.221 224.102 122.833C224.773 122.221 225.506 121.549 226.178 120.938Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46 119.654L227.398 119.716C227.398 119.716 227.46 119.716 227.46 119.654Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.397 119.715C227.214 119.898 227.031 120.082 226.848 120.265C227.031 120.143 227.214 119.959 227.397 119.715Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.608 91.4727C239.608 91.8394 239.608 92.2062 239.547 92.5119C239.547 92.2062 239.547 91.8394 239.608 91.4727Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.548 92.7568C239.548 93.1847 239.487 93.5515 239.426 93.9183C239.487 93.5515 239.487 93.1847 239.548 92.7568Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.169 117.759C229.046 117.881 228.985 118.003 228.863 118.126C228.924 118.003 229.046 117.881 229.169 117.759Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.351 117.514C229.595 117.208 229.84 116.964 230.023 116.658C229.718 117.025 229.412 117.392 229.168 117.759C229.229 117.697 229.29 117.636 229.351 117.514Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.861 118.126C228.373 118.676 227.945 119.226 227.457 119.654C227.884 119.165 228.373 118.676 228.861 118.126Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.245 114.947L231.184 115.009C231.245 115.009 231.245 115.009 231.245 114.947Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.069 106.45C236.069 106.45 236.069 106.512 236.008 106.512C236.069 106.512 236.069 106.512 236.069 106.45Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36 120.754C208.897 137.382 183.497 146.673 159.501 146.735C135.505 146.673 110.166 137.321 92.6427 120.754C87.2086 115.558 76.5845 100.887 80.0648 83.1591C88.674 67.3263 108.701 69.5881 122.317 81.264C124.271 82.9146 126.102 84.5039 127.934 85.9711C128.117 86.0933 140.329 95.4463 146.618 89.4555C154.678 81.8142 144.969 36.5166 128.667 23.7404C132.269 21.4174 136.116 19.4613 140.268 17.9941C146.679 31.6262 156.631 60.1741 157.059 84.8707C157.059 84.9319 157.059 84.993 157.059 85.1152C157.059 93.0011 159.44 92.512 159.44 92.512C159.44 92.512 161.821 93.0011 161.821 85.1152C161.821 85.0541 161.821 84.9319 161.821 84.8707C162.249 60.2352 172.201 31.6262 178.612 17.9941C182.764 19.4613 186.611 21.4174 190.213 23.7404C173.972 36.5166 164.203 81.8142 172.262 89.4555C178.551 95.3851 190.763 86.0933 190.946 85.9711C192.778 84.4428 194.61 82.9146 196.563 81.264C210.179 69.5881 230.267 67.3263 238.815 83.1591C242.357 100.887 231.794 115.619 226.36 120.754Z",
    fill: "url(#paint10_radial_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.406 67.8154C243.58 90.128 230.208 109.995 223.919 116.231C207.067 132.858 182.583 142.15 159.503 142.211C136.362 142.15 111.939 132.797 95.087 116.231C88.798 110.056 75.4263 90.1891 86.5999 67.8154C70.3585 91.9619 85.684 114.152 92.7057 120.754C110.168 137.382 135.568 146.674 159.564 146.735C183.56 146.674 208.899 137.321 226.423 120.754C233.322 114.152 248.648 91.9619 232.406 67.8154Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 111.768C172.2 111.768 171.711 113.969 171.223 115.803C169.88 120.938 166.399 130.719 159.5 130.719C151.501 130.719 148.082 117.392 147.288 113.785C147.166 113.235 146.922 111.707 146.922 111.707",
    stroke: "#B28560",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.895 112.747C171.895 112.747 168.781 130.78 159.5 130.78C150.219 130.78 147.105 112.93 147.105 112.93L148.754 113.297C150.464 113.603 152.234 113.603 153.822 113.297C155.715 112.93 157.424 112.074 158.584 110.791C159.073 110.24 159.5 110.24 159.928 110.791C161.088 112.135 162.797 112.93 164.69 113.297C166.278 113.603 168.048 113.603 169.758 113.297L171.895 112.747Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.407 117.637L164.567 113.174C162.735 112.807 159.377 109.506 159.316 108.834C159.316 109.506 156.141 112.624 154.492 113.052L155.652 117.576C155.774 118.065 156.263 118.431 156.812 118.431H162.308C162.796 118.554 163.285 118.187 163.407 117.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.499 121.427C155.958 121.427 152.905 122.71 151.195 124.667C153.149 128.029 155.836 130.78 159.499 130.78C163.163 130.78 165.849 128.029 167.742 124.667C166.093 122.71 163.041 121.427 159.499 121.427Z",
    fill: "#F2A694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.794 104.922C178.122 104.738 177.451 105.166 177.268 105.778C176.657 108.162 174.093 110.179 170.612 110.974C166.766 111.891 162.98 111.096 161.148 109.017C160.904 108.712 160.782 108.345 160.782 107.856V106.756V103.394C160.782 102.721 160.232 102.171 159.561 102.171C158.889 102.171 158.34 102.721 158.34 103.394V106.756V107.856C158.34 108.345 158.218 108.712 157.973 109.017C156.142 111.096 152.356 111.891 148.509 110.974C145.029 110.179 142.465 108.162 141.854 105.778C141.671 105.105 140.999 104.738 140.328 104.922C139.656 105.105 139.29 105.778 139.473 106.45C140.328 109.812 143.503 112.38 147.96 113.48C149.242 113.786 150.463 113.908 151.684 113.908C154.92 113.908 157.79 112.869 159.622 110.974C161.454 112.869 164.323 113.908 167.559 113.908C168.781 113.908 170.002 113.786 171.284 113.48C175.741 112.441 178.916 109.812 179.771 106.45C179.832 105.778 179.405 105.105 178.794 104.922Z",
    fill: "#B28560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32 93.6129C172.32 98.0142 164.26 103.455 159.498 103.455C154.369 103.455 146.676 97.9531 146.676 93.6129C146.676 89.2726 156.018 87.9277 159.498 87.9277C162.978 87.9889 172.32 89.2726 172.32 93.6129Z",
    fill: "url(#paint11_linear_197_177109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.497 92.0851C162.397 92.0851 164.748 91.6472 164.748 91.107C164.748 90.5668 162.397 90.1289 159.497 90.1289C156.597 90.1289 154.246 90.5668 154.246 91.107C154.246 91.6472 156.597 92.0851 159.497 92.0851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.764 74.0508C136.003 74.0508 141.06 68.9876 141.06 62.7417C141.06 56.4959 136.003 51.4326 129.764 51.4326C123.526 51.4326 118.469 56.4959 118.469 62.7417C118.469 68.9876 123.526 74.0508 129.764 74.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.765 71.3608C134.52 71.3608 138.375 67.5018 138.375 62.7414C138.375 57.9811 134.52 54.1221 129.765 54.1221C125.011 54.1221 121.156 57.9811 121.156 62.7414C121.156 67.5018 125.011 71.3608 129.765 71.3608Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.175 62.6039C135.958 62.2078 135.864 60.4457 134.967 58.6681C134.069 56.8905 132.707 55.7706 131.924 56.1667C131.142 56.5627 131.236 58.3248 132.133 60.1024C133.031 61.88 134.393 62.9999 135.175 62.6039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.627 66.5321C136.302 66.5321 136.849 65.9847 136.849 65.3095C136.849 64.6343 136.302 64.0869 135.627 64.0869C134.953 64.0869 134.406 64.6343 134.406 65.3095C134.406 65.9847 134.953 66.5321 135.627 66.5321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.296 74.0508C195.534 74.0508 200.591 68.9876 200.591 62.7417C200.591 56.4959 195.534 51.4326 189.296 51.4326C183.057 51.4326 178 56.4959 178 62.7417C178 68.9876 183.057 74.0508 189.296 74.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.297 71.3608C194.051 71.3608 197.906 67.5018 197.906 62.7414C197.906 57.9811 194.051 54.1221 189.297 54.1221C184.542 54.1221 180.688 57.9811 180.688 62.7414C180.688 67.5018 184.542 71.3608 189.297 71.3608Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.707 62.6049C195.489 62.2088 195.396 60.4467 194.498 58.6691C193.6 56.8915 192.238 55.7716 191.456 56.1676C190.673 56.5637 190.767 58.3258 191.664 60.1034C192.562 61.881 193.924 63.0009 194.707 62.6049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.159 66.5321C195.833 66.5321 196.38 65.9847 196.38 65.3095C196.38 64.6343 195.833 64.0869 195.159 64.0869C194.484 64.0869 193.938 64.6343 193.938 65.3095C193.938 65.9847 194.484 66.5321 195.159 66.5321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.004 91.228C220.669 91.228 225.262 89.3395 225.262 87.01C225.262 84.6804 220.669 82.792 215.004 82.792C209.339 82.792 204.746 84.6804 204.746 87.01C204.746 89.3395 209.339 91.228 215.004 91.228Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 91.228C109.665 91.228 114.258 89.3395 114.258 87.01C114.258 84.6804 109.665 82.792 104 82.792C98.3347 82.792 93.7422 84.6804 93.7422 87.01C93.7422 89.3395 98.3347 91.228 104 91.228Z",
    fill: "#F2857C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_177109",
    x1: 35.8646,
    y1: 222.5,
    x2: 110.885,
    y2: 219.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_177109",
    x1: 111.964,
    y1: 276.021,
    x2: 75.4055,
    y2: 199.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_177109",
    x1: 278.997,
    y1: 222.5,
    x2: 203.976,
    y2: 219.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_177109",
    x1: 202.897,
    y1: 276.021,
    x2: 239.456,
    y2: 199.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_197_177109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.587 140.626) rotate(90) scale(89.6106 40.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_197_177109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.916 10.3314) scale(36.9033 36.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_177109",
    x1: 195.87,
    y1: 28.874,
    x2: 227.58,
    y2: 30.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_197_177109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.134 10.3314) rotate(180) scale(36.9033 36.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_177109",
    x1: 123.183,
    y1: 28.874,
    x2: 91.473,
    y2: 30.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_197_177109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.478 87.5395) rotate(-90) scale(70.9164 88.0801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363052,
    stopColor: "#352F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6595,
    stopColor: "#565053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_197_177109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.242 51.9114) scale(95.8753 95.9889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3DFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#EFDAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#E9D0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#E1C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_177109",
    x1: 159.509,
    y1: 100.944,
    x2: 159.509,
    y2: 87.3088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_177109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 318,
    fill: "white",
    transform: "translate(51 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarGliderHappy);
export default __webpack_public_path__ + "static/media/sugarGlider_happy.ff7a928bd0008d50e2f013a917072840.svg";
export { ForwardRef as ReactComponent };